import { render, staticRenderFns } from "./NbCardItems.vue?vue&type=template&id=6877553c&scoped=true&"
import script from "./NbCardItems.vue?vue&type=script&lang=js&"
export * from "./NbCardItems.vue?vue&type=script&lang=js&"
import style0 from "./NbCardItems.vue?vue&type=style&index=0&id=6877553c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877553c",
  null
  
)

export default component.exports